import DOMPurify from 'dompurify'

const DEFAULT_CONFIG = {
  ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li', 'span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'code', 'pre', 'img', 'hr', 'table', 'thead', 'tbody', 'tr', 'th', 'td'],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style', 'src', 'alt', 'title'],
  ALLOW_DATA_ATTR: false
}

const TEXT_ONLY_CONFIG = {
  ALLOWED_TAGS: [],
  ALLOWED_ATTR: []
}

export function sanitizeHtml(dirty, config = {}) {
  if (!dirty) return ''
  if (typeof dirty !== 'string') return ''
  return DOMPurify.sanitize(dirty, { ...DEFAULT_CONFIG, ...config })
}

export function sanitizeText(dirty) {
  if (!dirty) return ''
  if (typeof dirty !== 'string') return ''
  return DOMPurify.sanitize(dirty, TEXT_ONLY_CONFIG)
}

export function formatContentSafe(content) {
  if (!content) return ''
  try {
    const parsed = JSON.parse('"' + content.replace(/"/g, '\\"') + '"')
    return sanitizeHtml(parsed.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>').replace(/\r/g, '<br>'))
  } catch (e) {
    return sanitizeHtml(
      content
        .replace(/\\r\\n/g, '<br>')
        .replace(/\\n/g, '<br>')
        .replace(/\\r/g, '<br>')
        .replace(/\r\n/g, '<br>')
        .replace(/\n/g, '<br>')
        .replace(/\r/g, '<br>')
    )
  }
}

export function sanitizeSvgIcon(iconHtml) {
  if (!iconHtml) return ''
  if (typeof iconHtml !== 'string') return ''
  return DOMPurify.sanitize(iconHtml, {
    ALLOWED_TAGS: ['svg', 'path', 'circle', 'rect', 'line', 'polyline', 'polygon', 'ellipse', 'g', 'defs', 'use', 'text', 'tspan', 'clippath', 'lineargradient', 'radialgradient', 'stop', 'mask'],
    ALLOWED_ATTR: ['d', 'viewBox', 'xmlns', 'fill', 'stroke', 'stroke-width', 'cx', 'cy', 'r', 'x', 'y', 'width', 'height', 'transform', 'class', 'id', 'href', 'xlink:href', 'offset', 'stop-color', 'stop-opacity', 'points', 'text-anchor', 'font-size', 'font-family', 'clip-path', 'mask', 'gradientunits', 'gradienttransform'],
    ALLOW_DATA_ATTR: false
  })
}
